import gql from 'graphql-tag';
import { nanoid } from 'nanoid';
import { graphMutation } from '@services/commService';
import { RESOURCES } from '@shared/Resources/types';

export const createTemporaryEntity = async (type) => {
  // Mentor Forms use their own database table and create mutation. The ID
  // here is only a temporary builder URL identifier; the form is persisted by
  // createMentorForm when the user saves it.
  if (type === RESOURCES.MENTOR_FORM) {
    return {
      errors: null,
      data: { entityId: `new-${nanoid()}` },
    };
  }

  const mutation = gql`
    mutation {
      entityId: createTemporaryEntity(type:${type})
    }
    `;
  const result = await graphMutation(mutation);
  return result;
};
